import { Burger } from './burger';
import { StickyHeader } from './sticky-header';

const header = document.querySelector('[data-header]');
const overlay = document.querySelector('[data-overlay]');
const burger = new Burger('[data-header]', '[data-burger]', overlay);

const onOverlayClose = (evt) => {
  evt.preventDefault();

  const target = evt.target;
  if (target === overlay) {
    burger._closeMenu();
  }
};

export const initBurger = function() {
  if (header) {
    burger.init();
    burger.setHeight();
    const stickyHeader = new StickyHeader();
    stickyHeader.init();
  }

  if (overlay) {
    overlay.addEventListener('click', onOverlayClose);
  }
};
